import lodashIsEmpty from 'lodash.isempty';

/**
 * Type guard wrapping lodash isEmpty.
 * When it returns false, TypeScript narrows `value` to `T`, excluding the empty-object case.
 */
const isEmpty = <T>(
  value: T | Record<string, never> | null | undefined,
): value is Record<string, never> | null | undefined => lodashIsEmpty(value);

export default isEmpty;
